if (typeof window.Backbone === 'undefined') {
  // eslint-disable-next-line
  const Backbone = require('backbone');
  window.Backbone = Backbone;
}

export default window.Backbone;



// WEBPACK FOOTER //
// ../globals/backbone.js